var win = window;

export var raf = win.requestAnimationFrame ||
  win.webkitRequestAnimationFrame ||
  win.mozRequestAnimationFrame ||
  win.msRequestAnimationFrame ||
  function(cb) { return setTimeout(cb, 16); };
